import types from '@/vuex/autuacao/mutations-types'

const mutations = {
  [types.EXIBIR_DIALOG_INTERESSADO]: (state) => {
    state.dialogInteressado = true
  },
  [types.ESCONDER_DIALOG_INTERESSADO]: (state) => {
    state.dialogInteressado = false
  },
  [types.EXIBIR_DIALOG_ASSUNTO]: (state) => {
    state.dialogAssunto = true
  },
  [types.ESCONDER_DIALOG_ASSUNTO]: (state) => {
    state.dialogAssunto = false
  },
  [types.EXIBIR_DIALOG_GLOSSARIO]: (state) => {
    state.dialogGlossario = true
  },
  [types.ESCONDER_DIALOG_GLOSSARIO]: (state) => {
    state.dialogGlossario = false
  },

  [types.SET_LISTA_TIPO_DOCUMENTO]: (state, payload) => {
    state.listaTipoDocumento = payload.listaTipoDocumento
  },
  [types.SET_LISTA_UNIDADE_PROCEDENCIA]: (state, payload) => {
    state.listaUnidadesProcedencia = payload.listaUnidadesProcedencia
  },
  [types.SET_LISTA_TIPO_INTERESSADO]: (state, payload) => {
    state.listaTiposInteressado = payload.listaTiposInteressado
  },
  [types.SET_LISTA_INTERESSADOS]: (state, payload) => {
    state.listaEntidadeInteressada = payload.listaEntidadeInteressada
  },
  [types.SET_LISTA_ASSUNTO]: (state, payload) => {
    state.listaAssunto = payload.listaAssunto
  },
  [types.SET_LISTA_ASSUNTO_NIVEL_1]: (state, payload) => {
    state.listaAssuntoNivel1 = payload.listaAssuntoNivel1
  },
  [types.SET_LISTA_ITENS_GLOSSARIO]: (state, payload) => {
    state.listaItensGlossario = payload.listaItensGlossario
  },

  [types.SET_TIPO_DOCUMENTO]: (state, payload) => {
    state.tipoDocumento = payload.tipoDocumento
  },
  [types.SET_UNIDADE_PROCEDENCIA]: (state, payload) => {
    state.unidadeProcedencia = payload.unidadeProcedencia
  },
  [types.SET_TIPO_INTERESSADO]: (state, payload) => {
    state.tipoInteressado = payload.tipoInteressado
  },
  [types.SET_INTERESSADO]: (state, payload) => {
    state.interessado = payload.interessado
  },
  [types.SET_ASSUNTO]: (state, payload) => {
    state.assunto = payload.assunto
  },
  [types.SET_RESUMO_ASSUNTO]: (state, payload) => {
    state.resumoAssunto = payload.resumoAssunto
  },
  [types.SET_URGENTE]: (state, payload) => {
    state.urgente = payload.urgente
  },
  [types.SET_MOTIVO_URGENCIA]: (state, payload) => {
    state.motivoUrgencia = payload.motivoUrgencia
  },
  [types.SET_DOCUMENTO_ORIGEM]: (state, payload) => {
    state.documentoOrigem = payload.documentoOrigem
  },
  [types.SET_EMITENTE]: (state, payload) => {
    state.emitente = payload.emitente
  },
  [types.SET_DATA_DOCUMENTO_ORIGEM]: (state, payload) => {
    state.dataDocumentoOrigem = payload.dataDocumentoOrigem
  },
  [types.SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM]: (state, payload) => {
    state.dataRecebimentoDocumentoOrigem = payload.dataRecebimentoDocumentoOrigem
  },
  [types.SET_OBSERVACAO]: (state, payload) => {
    state.observacao = payload.observacao
  },
  [types.SET_DOCUMENTO]: (state, payload) => {
    state.documento = payload.documento
  },
  [types.SET_BUSCANDO_DOCUMENTO_ORIGEM]: (state, payload) => {
    state.buscandoDocumentoOrigem = payload.buscandoDocumentoOrigem
  }
}
export default mutations
